import * as React from 'react';
import api from './ApiClient';

interface Division {
	id: string;
	name: string;
	description: string;
}

interface DivisionDropDownProps {
	seriesId: string;
	value?: string | null;
	onChange: (divisionId: string | null) => void;
	includeNone?: boolean;
}

interface DivisionDropDownState {
	divisions: Division[];
}

export default class DivisionDropDown extends React.Component<DivisionDropDownProps, DivisionDropDownState> {
	
	state: DivisionDropDownState = {
		divisions: []
	};

	componentDidMount() {
		if (this.props.seriesId) {
			this.loadDivisions(this.props.seriesId);
		}
	}

	componentDidUpdate(prevProps: DivisionDropDownProps) {
		if (prevProps.seriesId !== this.props.seriesId) {
			this.loadDivisions(this.props.seriesId);
		}
	}

	loadDivisions(seriesId: string) {
		api.request('divisions?seriesId=' + seriesId).then((data: Division[]) => {
			this.setState({ divisions: data });
		});
	}

	handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const value = event.target.value;
		this.props.onChange(value === '' ? null : value);
	}

	render() {
		const { value, includeNone = true } = this.props;

		return (
			<select 
				className="form-control" 
				value={value || ''} 
				onChange={this.handleChange}
			>
				{includeNone && (
					<option value="">No Division</option>
				)}
				{this.state.divisions.map(division => (
					<option key={division.id} value={division.id}>
						{division.name}
					</option>
				))}
			</select>
		);
	}
}
